import {
  appealUserConstants
} from './constants'
import api from './api';
import { defAction } from "../../../helpers/defaultAction";

export const appealUserActions = {
  getUsersByReOrgId,
  getReOrgInfoByUser,
  getUserExecutPosition,
  getAppealUserAddress,
  clearAppealUserAddress,
  getReOrgInfoByReOrgId,
  clearReOrgInfo
}

function getUsersByReOrgId(params) {
  const dispatchObj = {
    constants: appealUserConstants.GetUsersByReOrgId,
    service: {
      func: api.GetUsersByReOrgId,
      params: params,
    },
  };

  return defAction(dispatchObj);
}


function getReOrgInfoByUser() {
  const dispatchObj = {
    constants: appealUserConstants.GetReOrgInfoByUser,
    service: {
      func: api.GetReOrgInfoByUser,
    },
  };

  return defAction(dispatchObj);
}

function getUserExecutPosition() {
  const dispatchObj = {
    constants: appealUserConstants.GetUserExecutPosition,
    service: {
      func: api.GetUserExecutPosition,
    },
  };

  return defAction(dispatchObj);
}

function getAppealUserAddress(params) {
  const dispatchObj = {
    constants: appealUserConstants.GetAppealUserAddress,
    service: {
      func: api.GetAppealUserAddress,
      params: params,
    },
  };

  return defAction(dispatchObj);
}

function clearAppealUserAddress() {
  return (dispatch) =>
    dispatch({
      type: appealUserConstants.GetAppealUserAddress.CLEAR
    })
}


function getReOrgInfoByReOrgId(params) {
  const dispatchObj = {
    constants: appealUserConstants.GetReOrgInfoByReOrgId,
    service: {
      func: api.GetReOrgInfoByReOrgId,
      params: params,
    },
  };

  return defAction(dispatchObj);
}

function clearReOrgInfo() {
  return (dispatch) =>
    dispatch({
      type: appealUserConstants.GetReOrgInfoByReOrgId.CLEAR
    })
}
